export const DEFAULT_DATA_ADJUSTMENT_STATE = {
  ndx: null,
  collect_date: null,
  ap_ndx: null,
  col_ndx: null,
  override_value: null,
  notes: null,
};
